import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showError } from "../../utils/messageHelper";
import { createToneApi } from "../../services/tones/api";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  responseCode: 0,
  errorMessage: "",
  responseData: [],
};

export const createTone = createAsyncThunk(
  "user/createTone",
  async (payload) => {
    try {
      const data = await createToneApi(payload);
      return data;
    } catch (e) {
      showError(e.response.data.responseMessage);
      return e;
    }
  }
);

export const createToneSlice = createSlice({
  name: "createTone",
  initialState,
  reducers: {},
  extraReducers: {
    [createTone.pending]: (state) => {
      state.isLoading = true;
    },
    [createTone.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.responseData = payload?.data?.responseData;
      state.responseCode = payload.status;
    },
    [createTone.rejected]: (state, payload) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = payload.responseMessage;
    },
  },
});

export const createToneReducer = createToneSlice.reducer;
